import { Component, h, Host, Prop } from '@stencil/core';

@Component({
  tag: 'afs-image',
  styleUrl: 'afs-image.sass',
  shadow: true,
})
export class AfsImage {

  @Prop() href : string;
  @Prop() src : string;
  @Prop() alt : string;
  @Prop() fit : string = 'cover';
  @Prop() position : string = 'center';
  @Prop() ratioFit : boolean = false;

  render() {

    const imageTemplate = <img 
      src={this.src}
      alt={this.alt}
      style={{
        objectFit: this.fit,
        objectPosition: this.position,
      }}
      class={this.ratioFit ? 'ratio' : 'standard'}
    />

    return (
      <Host>
        {this.href ? <afs-link href={this.href}>{imageTemplate}</afs-link> : imageTemplate}
      </Host>
    );
  }

}
